import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ICreateAssessmentRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createGoogleAssessmentCheckThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(ApplyProcessActionTypes.CreateGoogleAssessment,
    async (body: ICreateAssessmentRequest) => {
    const response = await api.createAssessment(body);

    return response;
  });
